import React, { Component } from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import classNames from 'classnames'
import Button from './generic/Button'
const CopyButton = Button.withComponent('div')

class CopyToClipboardButton extends Component {
	constructor(props) {
		super()
		this.state = {
			copied: false
		}
	}

	handleCopy = (copiedText) => {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(copiedText) // Try to clean rich text styles: https://github.com/nkbt/react-copy-to-clipboard/issues/42#issuecomment-436688282
		}
		this.setState({copied: true})
		setTimeout(() => {
			this.setState({copied: false})
		}, 2000)
		return true
	}

	render() {
		let { label } = this.props

		label = label || "Copy Invite Link"

		if (this.state.copied) {
			label = "Copied!"
		}
		return (
			<div className='share-links' style={{'marginBottom': '10px', ...this.props.style}}>
				<CopyToClipboard text={this.props.text} onCopy={this.handleCopy}>
          <CopyButton secondary small className={classNames("copy-clipboard-btn", {"copied": this.state.copied})}>
          	{label}
          </CopyButton>
        </CopyToClipboard>
			</div>
		)
	}
}

export default CopyToClipboardButton